import type { IModelConnection } from "@itwin/core-frontend";
import { QueryBinder, QueryRowFormat } from "@itwin/core-common";
import { Asset } from "../../../domain/assets/Asset";
import { DOTPayItemIndex } from "./dotPayItemQuery";

const DOTPAYITEM_SCHEMA =
  "DgnCustomItemTypes_DOT_DigitalAssetMetadata";

/**
 * Build the ECSQL to read Asset info
 * for a given DOT_PayItem{index} aspect.
 */
function buildAssetByElementQuery(index: DOTPayItemIndex): string {
  if (index < 1 || index > 5) {
    throw new Error(`Invalid DOT_PayItem index: ${index}`);
  }

  return `
    SELECT
      p.Asset.Project_ID  AS Project_ID,
      p.Asset.Project     AS Project,
      p.Asset.[Index]     AS [Index],
      p.Asset.Status      AS Status,
      p.Asset.Instance    AS Instance,
      p.Asset.PlanID      AS PlanID,
      p.Asset.PlanDecoder AS PlanDecoder,
      p.Asset.IsTracked   AS IsTracked,
      p.Asset.AssetID     AS AssetID
    FROM ${DOTPAYITEM_SCHEMA}.DOT_PayItem${index}ElementAspect p
    WHERE p.Element.Id = ?
  `;
}

export async function queryAssetForElement(
  iModel: IModelConnection,
  elementId: string,
  index: DOTPayItemIndex,
): Promise<Asset | undefined> {
  const bindings = QueryBinder.from([elementId]);

  const reader = iModel.createQueryReader(
    buildAssetByElementQuery(index),
    bindings,
    { rowFormat: QueryRowFormat.UseECSqlPropertyNames }
  );

  for await (const row of reader) {
    const plain = row.toRow() as any; // { Project_ID, Project, Index, Status, Instance, PlanID, PlanDecoder, IsTracked, AssetID }
    return Asset.fromObject(plain);
  }

  // No Asset info for that element/index
  return undefined;
}

